<template>
  <div class="min-h-screen flex items-center justify-center bg-secondary-50 dark:bg-secondary-900 px-4">
    <div class="max-w-md w-full text-center">
      <div class="text-9xl font-bold text-warning-600 dark:text-warning-400">503</div>
      <h1 class="mt-4 text-3xl font-bold text-secondary-900 dark:text-white">Under Maintenance</h1>
      <p class="mt-2 text-secondary-600 dark:text-secondary-400">
        We're currently performing scheduled maintenance. We'll be back soon!
      </p>
      <p class="mt-2 text-sm text-secondary-500 dark:text-secondary-500">
        This maintenance is necessary to improve your experience.
      </p>
      <div class="mt-8">
        <button
          @click="checkStatus"
          class="inline-flex items-center justify-center px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors font-medium"
        >
          <ArrowPathIcon class="h-5 w-5 mr-2" />
          Check Status
        </button>
      </div>
      <!-- Estimated time if provided -->
      <div v-if="estimatedTime" class="mt-8 text-sm text-secondary-500 dark:text-secondary-400">
        <p>Estimated completion: {{ estimatedTime }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ArrowPathIcon } from '@heroicons/vue/24/outline';

const props = defineProps({
  estimatedTime: {
    type: String,
    default: null,
  },
});

const checkStatus = () => {
  window.location.reload();
};
</script>
